// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3sET0","box":"WorkspacesBox_box__eOcVP","node":"WorkspacesBox_node__1XxPI"};